import { FC, ReactNode } from "react"
import mainLogo from "@/assets/reassurance-logo.png"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import "./index.scss"

interface AuthLayoutProps {
   iconName: IconProps["name"]
   title: string
   instructions: ReactNode
   children: ReactNode
}

const AuthLayout: FC<AuthLayoutProps> = ({
   iconName,
   title,
   instructions,
   children,
}) => {
   return (
      <Grid
         className="auth-layout"
         columnGap={0}
      >
         <GridItem
            className="auth-layout__instructions-wrapper"
            size={6}
         >
            <div className="auth-layout__instructions">
               <div className="auth-layout__instructions-header">
                  <Icon
                     name={iconName}
                     color={IconColor.WHITE}
                     size="80"
                  />
                  <span className="auth-layout__instructions-header-text">
                     {title}
                  </span>
               </div>
               {instructions}
            </div>
         </GridItem>
         <GridItem
            className="auth-layout__form-wrapper"
            size={6}
         >
            <div className="auth-layout__form">
               <img
                  className="auth-layout__banner"
                  src={mainLogo}
                  alt="logoBanner"
               />
               {children}
            </div>
         </GridItem>
      </Grid>
   )
}

export default AuthLayout
